export default "__VITE_ASSET__83e1400c__"